import RoleHome from '../../components/RoleHome/RoleHome';
export default function ManagerHome() {
  return <RoleHome role="manager" />;
}